import { Component, OnInit } from '@angular/core';
import { RxFormBuilder, RxFormGroup } from '@rxweb/reactive-form-validators';
import { ConfirmationService, MessageService } from 'primeng/api';
import { DynamicDialogConfig, DynamicDialogRef } from 'primeng/dynamicdialog';
import { FormValidatorService } from 'src/app/core/services/form-validator.service';
import { LoginService } from 'src/app/modules/login/login.service';
import { RatesService } from 'src/app/modules/rates/_services/rates.service';
import { WorkerContract } from '../../_types/worker-contract';
import { TypeContractsService } from 'src/app/modules/common/_services/type-contracts.service';
import { ColectiveAgreementsService } from 'src/app/modules/common/_services/colective-agreements.service';
import { firstValueFrom } from 'rxjs';
import { WorkerContractsService } from '../../_services/workers-contracts.service';

@Component({
    selector: 'app-worker-contract',
    templateUrl: './worker-contract.component.html',
    styleUrls: ['./worker-contract.component.css'],
    standalone: false
})
export class WorkerContractComponent implements OnInit {

  public workerContractFormGroup!: RxFormGroup;
  public workerContract: WorkerContract = new WorkerContract();
  public rates: any[] = [];
  public allowWrite: boolean = false;
  public allowDelete: boolean = false;
  public typesContracts: any[] = [];
  public colectiveAgreements: any[] = [];

  constructor(private config: DynamicDialogConfig,
      private messageService: MessageService,
      private dynamicDialogRef: DynamicDialogRef,
      private confirmationService: ConfirmationService,
      private formBuilder: RxFormBuilder,
      private formValidationService: FormValidatorService,
      private ratesService: RatesService,
      private loginService: LoginService,
      private typesContractsService: TypeContractsService,
      private colectiveAgreementsService: ColectiveAgreementsService,
      private workerContractService: WorkerContractsService
    ) 
    {
      this.workerContractFormGroup = this.formBuilder.formGroup<WorkerContract>(this.workerContract) as RxFormGroup; 
    }

  ngOnInit() {
    console.log(this.config.data);

    if (this.config.data.workerContractId) {
      this.loadData(this.config.data.workerContractId);
    } else {
      this.workerContract.workerId = this.config.data.workerId;
    }
    this.loadTypesContracts();
    this.loadColectiveAgreements();

    this.allowWrite = this.loginService.hasPermission("WORKERS.WRITE");
    this.allowDelete = this.loginService.hasPermission("WORKERS.DELETE");
  }

  async loadTypesContracts() {
    let response = await firstValueFrom(this.typesContractsService.all({ page: { number: 1, size: 1000 } }));
    this.typesContracts = response.data;
  }


  async loadColectiveAgreements() {
    let response = await firstValueFrom(this.colectiveAgreementsService.all({ page: { number: 1, size: 1000 } }));
    this.colectiveAgreements = response.data;
  }
  
  async loadData(id: string){
    this.workerContract = await firstValueFrom(this.workerContractService.get(id));
    this.workerContractFormGroup.patchValue(this.workerContract);
  }

  delete(){
    this.confirmationService.confirm({
      message: "¿Está seguro que desea eliminar el contrato?",
      header: "Eliminar contrato",
      acceptLabel: "Aceptar",
      rejectLabel: "Cancelar",
      acceptButtonStyleClass: "p-button-danger",
      icon: 'pi pi-exclamation-triangle',
      accept: () => {
        this.workerContractService.delete(this.workerContract.id).subscribe({
          next: (data: any) => {
            this.cancel();
            this.messageService.add({ closable: true, severity: 'success', detail: "Contrato eliminado correctamente." });
          },
          error: (error: any) => {
            this.messageService.add({ closable: true, severity: 'error', detail: error.error.title });
          }
        });
      },
      reject: () => {
      }
    });
  }

  cancel(){
    this.dynamicDialogRef.close();
  }

  async save(){
    let valid = this.formValidationService.validateForm(this.workerContractFormGroup);
    if (valid) {
      this.workerContract = Object.assign(this.workerContract, this.workerContractFormGroup.value);
      await firstValueFrom(this.workerContractService.save(this.workerContract!));      
      
        this.messageService.add({ closable: true, severity: 'success', summary: "Éxito", detail: "Contrato guardado correctamente." });
        this.dynamicDialogRef.close(this.workerContract);
    }
  }

  calculateHourlyCost(){
    console.log("entra en calculateHourlyCost");
    
    if(this.workerContractFormGroup.get("salary")?.value && this.workerContractFormGroup.get("hours")?.value){
      var hourlyCost = (this.workerContractFormGroup.get("salary")?.value / 12 + 1.33)/(this.workerContractFormGroup.get("hours")?.value * 4.33);
       this.workerContractFormGroup.patchValue({ hourlyCost: hourlyCost });

    }else{
       this.workerContractFormGroup.patchValue({ hourlyCost: 0 });
    }
  }

}
